function createProductQuoteFormConfig(withLabels = true) {
  return {
    productQuoteForm: {
      title: 'New Part Quote',
      fields: ['quantity', 'unitCost', 'currency', 'supplier'],
      styles: {
        labelBold: true,
      },
    },
    fields: {
      quantity: {
        type: 'jobSpecQuantity',
        shouldRenderFieldLabel: withLabels,
      },
      currency: {
        label: 'Currency',
        component: 'forms.SelectField',
        placeholder: 'Please select',
        labelKey: 'label',
        appKey: 'value',
        options: {
          default: 'EUR',
          values: [
            {
              label: 'US Dollars',
              value: 'USD',
            },
            {
              label: 'Euros',
              value: 'EUR',
            },
            {
              label: 'Pound Sterling',
              value: 'GBP',
            },
          ],
        },
      },
      unitCost: {
        label: 'Unit Cost',
        placeholder: '00.00',
        component: 'forms.DecimalField',
        shouldRenderFieldLabel: withLabels,
        style: {
          minWidth: '120px',
        },
      },
      supplier: {
        type: 'manufacturer',
      },
    },
  };
}

function createExtendQuoteFormConfig() {
  return {
    extendQuoteForm: {
      title: 'Extend Valid Until Date',
      fields: ['validUntil'],
      styles: {
        labelBold: true,
      },
    },
    fields: {
      validUntil: {
        label: 'Extends To',
        placeholder: 'DD / MM / YYYY',
        component: 'forms.DateField',
        validator: 'futureDate',
      },
    },
  };
}

export const productQuoteFormConfig = createProductQuoteFormConfig();
export const extendQuoteFormConfig = createExtendQuoteFormConfig();

export const productQuoteFormConfigNoLabels =
  createProductQuoteFormConfig(false);
